<app-block-wrapper [_editable]="_editable" [style]="style">
  <div class="button-list-wrapper">
    <div class="button-list gap-{{ buttonSpacing || '2' }}">
      @for (button of buttons; track $index) {
        @if (button.component === 'button_list_item') {
          <app-storyblok-button-item [button]="button" (onClick)="onClick($event)"></app-storyblok-button-item>
        } @else if (button.component === 'button_list_dropdown_item') {
          <app-context-menu [options]="{ width: '240px', noSpacing: true }">
            <app-storyblok-button-item contextButton [button]="button.button[0]"></app-storyblok-button-item>

            <div class="button-menu" contextContent>
              @for (button of button.dropdownButtons; track button) {
                @if (button.component === 'button_list_item') {
                  <app-storyblok-button-item [button]="button" (onClick)="onClick($event)"></app-storyblok-button-item>
                } @else if (button.component === 'button_list_line_item') {
                  <div class="divider"></div>
                }
              }
            </div>
          </app-context-menu>
        } @else {
          {{ button.component }}
        }
      }
    </div>
  </div>
</app-block-wrapper>
